import React, { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import i18n from 'i18n-js';

import ColorWrapper from '@styles/colors';
import { font } from '@styles/fonts';

import { ValidationErrorsPopupProps } from './types';
import { useManageValidationErrorsPopup } from './hooks/useManageValidationErrorsPopup';
import ValidationWarningItem from './components/ValidationWarningItem';
import { scale } from '@components/frame';

const ValidationErrorsPopup: FC<ValidationErrorsPopupProps> = ({ connectorDetailsCode, validationWarnings, containerStyle, C }) => {
  const { groupedWarnings } = useManageValidationErrorsPopup({ validationWarnings });

  return (
    <View style={[styles.mainContainer, containerStyle]}>
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>
        {i18n.t('Your {{connectorDetailsCode}} Connection is enabled.', { connectorDetailsCode })}
      </Text>
      {groupedWarnings.map((group) => (
        <View key={group.validationContextName} style={styles.group}>
          <Text style={[font['Subhead 2'], { color: C('Label/Light/Primary') }]}>{i18n.t(group.description)}</Text>
          <View style={styles.list}>
            {group.warnings.map((warning) => (
              <ValidationWarningItem key={`${warning.validationContextName}-${warning.validationContextValue}`} warning={warning} C={C} />
            ))}
          </View>
        </View>
      ))}
      <Text style={[font['Subhead 2'], { color: C('Label/Light/Tertiary') }]}>
        {i18n.t('ERP data sync is not affected. Files on these drives will be unavailable until the issue is resolved.')}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: { alignItems: 'center', alignSelf: 'stretch' },
  group: { width: '100%', marginTop: scale(10) },
  list: { gap: scale(6), marginBottom: scale(12), marginTop: scale(10) },
  headlineMargin: { marginBottom: scale(10) },
});

export default ColorWrapper(ValidationErrorsPopup);
